module.exports = __webpack_public_path__ + "img/my image - Md Kashif19MEB134.72e11275.jpg";